import {
    FETCH_START,
    FETCH_END, TABLE_LIST
} from '../../../actions/DataSetup/ManipulateData/ActionTypes';
const initialState = {
    loading: false,
    editableTables: {}
}
const ManipulateDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_START:
            return {
                ...state,
                loading: true,
            };
        case FETCH_END:
            return {
                ...state,
                loading: false,
            };
        case TABLE_LIST:
            return {
                ...state,
                editableTables: action.data,
            };
        default:
            return state;
    }
};

export default ManipulateDataReducer;